import log from "Logger";
import { datadogRum } from "@datadog/browser-rum";
import { updateDataDogIdentity } from "../thirdParty/DataDog/DataDog";
import { getIsTestSeller } from "organization/utils/getIsTestSeller";
import { SPThunkAction } from "common/ReduxUtils";

/**
 * Tracks user login time in Datadog by updating user attributes
 */
export const trackUserLoginTime = (): SPThunkAction => (_, getState) => {
  try {
    if (!datadogRum?.setUser) {
      log.warn({ fn: "trackUserLoginTime" }, "Datadog RUM setUser not available");
      return;
    }

    const loginTimestamp = new Date().toISOString();
    const state = getState();

    const { user, organization } = state;
    const isTestSeller = getIsTestSeller({
      email: user.email,
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      isTestAccount: organization.isTestAccount || user.groups.includes("admin"),
    });
    // Update user attributes in Datadog with login time
    updateDataDogIdentity({ user: { ...user, isTestSeller, lastLoginTime: loginTimestamp } });

    log.info(
      { fn: "trackUserLoginTime", userId: user.sellerId, loginTime: loginTimestamp },
      "User login time set as user attribute in Datadog"
    );
  } catch (err) {
    log.warn({ fn: "trackUserLoginTime", err }, "Error setting user login time in Datadog");
  }
};
